import React from 'react';
import {connect} from 'react-redux';
import ProgressCircle from './ProgressCircle';
import DateList from './DateList';
import AppTheme from '../components/AppTheme';
import ErrorMessage from './ErrorMessage';

const ViewSelector=({result,waiting, error})=>{
    return(<div>
        {waiting ? <div className='in-the-center'><ProgressCircle size={100}/></div>
            : (result==='DATE_USERS'? <DateList/>
            : (error !== undefined ? <ErrorMessage/>
            :(result===undefined?<div className='in-the-center'><p>Нет данных</p></div> :'')))
        }
    </div>);
};

const mapStateToProps=(state)=>({result:state.process.result,waiting:state.process.waiting, error : state.process.error});
export default connect(mapStateToProps)(ViewSelector);
